// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

   

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const storedUser = localStorage.getItem('ocr_user');
        if (storedUser) {
          // Add token validation logic here if needed
          setUser(JSON.parse(storedUser));
        }
      } catch (error) {
        console.error('Auth check failed:', error);
      } finally {
        setLoading(false);
      }
    };
  
    checkAuth();
  }, []);

  const login = async (email, password) => {
    // Static credentials - replace with API call later

    if (email === 'superadmin@ocr.com' && password === 'admin123') {
      const userData = {
        email,
        role: 'superadmin',
        token: 'superadmin-fake-token',
        organizations: [] 
      };
      
      localStorage.setItem('ocr_user', JSON.stringify(userData));
      setUser(userData);
      navigate('/super-admin-dashboard');
      return;
    }

    if (email === 'admin@ocr.com' && password === 'admin123') {
      const fakeToken = 'fake-jwt-token'; // Replace with real token from API
      const userData = {
        email,
        token: fakeToken,
        role:'admin',
        organization: 'Demo Organization'
      };
      
      localStorage.setItem('ocr_user', JSON.stringify(userData));
      setUser(userData);
      navigate('/dashboard');
      return;
    }
    throw new Error('Invalid credentials');
  };

  const logout = () => {
    localStorage.removeItem('ocr_user');
    setUser(null);
    navigate('/login');
  };

  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user?.token
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};